import request from "@/utils/request";

// 发现-店长素材 列表
export function getMaterialList(params) {
  return request({
    url: "/setting/fodder/h5/page",
    method: "get",
    params,
  });
}
// 发现-店长素材 创建
export function createMaterial(data) {
  return request({
    url: '/setting/fodder/addFodder',
    method: 'post',
    data
  })
}
// 发现-店长素材 商品列表
export function getMaterialGoodsList(params) {
  return request({
    url: '/trade/order/h5/queryOrderItem',
    method: 'get',
    params
  })
}
// 发现-店长素材 详情
export function getMaterialDetail(id) {
  return request({
    url: '/setting/fodder/detail/' + id,
    method: 'get'
  })
}

// 发现-官方公告 列表
export function getOfficialList(params) {
  return request({
    url: '/setting/notice/h5/queryNoticePage',
    method: 'get',
    params
  })
}
// 发现-官方公告 详情
export function getOfficialDetail(id) {
  return request({
    url: '/setting/notice/queryNoticeDetail',
    method: 'get',
    params: { id }
  })
}

// 发现-新人成长 列表
export function getGrowingList(params) {
  return request({
    url: '/setting/growth-college/h5/queryCollegePage',
    method: 'get',
    params
  })
}
// 发现-新人成长 详情
export function getGrowingDetail(id) {
  return request({
    url: '/setting/growth-college/queryCollegeDetail',
    method: 'get',
    params: { id }
  })
}

// 喜欢
export function favorites(params) {
  return request({
    url: '/setting/fodder/h5/like',
    method: 'get',
    params
  })
}
// 取消喜欢
export function favoritesCancel(params) {
  return request({
    url: '/setting/fodder/h5/dislike',
    method: 'get',
    params
  })
}


// 商品页面-精选素材
export function getMaterialByGoodsId(params) {
  return request({
    url: '/setting/fodder/h5/handpick',
    method: 'get',
    params
  })
}
// 品牌会场-发现
export function getMaterialByBrandPlace(params) {
  return request({
    url: '/setting/fodder/h5/discover',
    method: 'get',
    params
  })
}

// 转发
export function sharePoster(data) {
  return request({
    url: '/setting/fodder/h5/fodder/forward',
    method: 'post',
    data
  })
}
// 判断商品是否活动中
export function getActivityDetail(id) {
  return request({
    url: "/product/activity/h5/" + id,
    method: "get",
  })
}